import { IScheduledCustomReport } from '@/Interfaces/ReportBuilder/ScheduledCustomReport.interface';
import {
  CustomReportCancelScheduledFunction,
  CustomReportEditScheduledFunction,
} from '@/types/ReportBuilder/GridFunction.types';
import { Button, Stack, buttonClasses } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { memo } from 'react';

interface IProps extends GridRenderCellParams<IScheduledCustomReport> {
  onCancelScheduledReport: CustomReportCancelScheduledFunction;
  onEditScheduledReport: CustomReportEditScheduledFunction;
}

const pillSx = {
  borderRadius: '32px',
  padding: '4px 12px',
  fontSize: '12px',
  [`& .${buttonClasses.startIcon}`]: {
    marginRight: '4px',
  },
} as const;

const ActionChip = memo(({ row, onCancelScheduledReport, onEditScheduledReport }: IProps) => {
  if (!row?.id) return 'N/A';
  return (
    <Stack direction='row' spacing={1}>
      <Button variant='outlined' onClick={() => onEditScheduledReport(row)} sx={pillSx}>
        Edit
      </Button>
      <Button variant='outlined' onClick={() => onCancelScheduledReport(row.id)} sx={pillSx}>
        Cancel
      </Button>
    </Stack>
  );
});

export default ActionChip;
